import { render, staticRenderFns } from "./listOld.vue?vue&type=template&id=47b7861b"
import script from "./listOld.vue?vue&type=script&lang=js"
export * from "./listOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_d02125917f7c66a571cdcbfa3dd68341/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('47b7861b')) {
      api.createRecord('47b7861b', component.options)
    } else {
      api.reload('47b7861b', component.options)
    }
    module.hot.accept("./listOld.vue?vue&type=template&id=47b7861b", function () {
      api.rerender('47b7861b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/complaint/listOld.vue"
export default component.exports